import { createUseStyles } from 'react-jss'
import { colors } from '#base/js/variables.style'

export const style = {
  icon: {
    color: 'var(--theme-status-warning)'
  }
}

export const useStyles = createUseStyles(style)
